/**
 * SortSelector Component
 * Dropdown for sorting listings in CategoryPage
 */
import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

const SortSelector = ({
  value,
  onChange,
  options = null,
  className = "w-48"
}) => {
  const defaultOptions = [
    { value: 'recent', label: 'Most Recent' },
    { value: 'relevance', label: 'AI Ranked', icon: '✨' },
    { value: 'price-low', label: 'Price: Low to High' },
    { value: 'price-high', label: 'Price: High to Low' },
    { value: 'popular', label: 'Most Popular' }
  ];

  const sortOptions = options || defaultOptions;

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className} data-testid="sort-selector">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {sortOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.icon ? (
              <span className="flex items-center gap-1">
                {option.icon} {option.label}
              </span>
            ) : (
              option.label
            )}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default SortSelector;
